import { JSXElement } from 'solid-js';

const getTncLinkTransformer =
  (href: string): ((s: string) => JSXElement) =>
  (str: string) => {
    return (
      <a
        class={`text-fg-default underline`}
        href={href}
        target={'_blank'}
      >
        {str}
      </a>
    );
  };

const getKbLinkTransformer =
  (href: string, dataTestId?: string): ((s: string) => JSXElement) =>
  (str: string): JSXElement =>
    href ? (
      <a
        class={`text-link-primary`}
        href={href}
        target={'_blank'}
        {...(dataTestId ? { 'data-testid': dataTestId } : {})}
      >
        {str}
      </a>
    ) : (
      <></>
    );

const boldTransformer = (str: string) => {
  return <span class={`font-semibold`}>{str}</span>;
};

export { getTncLinkTransformer, getKbLinkTransformer, boldTransformer };
